import { Col } from "reactstrap";
import SearchInput from "./SearchInput";
import { UL } from "../../../AbstractElements";
import DarkMode from "./DarkMode/DarkMode";
import ResponsiveSearch from "./ResponsiveSearch";
import NotificationHeader from "./NotificationHeader/NotificationHeader";
import UserProfile from "./UserProfile/UserProfile";

const MainHeader = () => {
  return (
    <Col className="page-main-header">
      <SearchInput />
      <div className="nav-right">
        <UL className="header-right flex-row simple-list overflow-visible">
          <DarkMode />
          <ResponsiveSearch />
          <NotificationHeader />
          <UserProfile />
        </UL>
      </div>
    </Col>
  );
};

export default MainHeader;
